module.exports = __webpack_public_path__ + "static/media/rnn-logo.9e69e53e.png";